export default {
      id: "monitor-white-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#monitor-white",
      toString: function () {
        return this.url;
      }
    }